import React, { useState, useEffect } from "react";
import nodata from "../assets/images/nodata.png";
import Header from "../components/Header";
import Session from "../utils/sessionStorage";
import axiosInstance from "../utils/axiosInstance";
import ErrorModal from "../components/ErrorModal";
import { X_API_KEY } from "../constants/ServerUrl";
import ShimmerSkeleton from "../components/ShimmerSkeleton";
import { isAddPlanDisabled } from "../utils/profileutils";

const History = () => {
  const [history, setHistory] = useState([]);
  const [RechargeHistory, setRechargeHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("recharge");
  const [errorModal, setErrorModal] = useState({ open: false, message: "" });
  const result = Session.get("_user_");
  const userData = result ? JSON.parse(result) : "";
  const userMob = userData?.mobileNo;
  const [disableAddPlan, setDisableAddPlan] = useState(null);

  useEffect(() => {
    setDisableAddPlan(isAddPlanDisabled());
  }, []);

  console.log("uswe :", userMob);

  const fetchSubscriptionHistory = async () => {
    const url = disableAddPlan
      ? `/api/v1/get-subscription-history?msisdn=${userMob}`
      : `/api/v2/get-subscription-history?msisdn=${userMob}`;
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        url,
        {
          headers: {
            'X-API-KEY': X_API_KEY,
          },
        }
      );
      if (response.status === 200) {
        setHistory(response?.data?.subscription_history || []);
      }
      console.log("history", response?.data?.subscription_history);
    } catch (error) {
      setErrorModal({ open: true, message: error?.response?.data?.message || "Failed to fetch history" });
    } finally {
      setLoading(false);
    }
  };
  const fetchRechargeHistory = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `api/v1/get-recharge-history?msisdn=${userMob}`,
        {
          headers: {
            'X-API-KEY': X_API_KEY,
          },
        }
      );
      if (response.status === 200) {
        setRechargeHistory(response?.data?.recharge_history || []);
      }
      console.log("history recharge", response?.data?.recharge_history);
    } catch (error) {
      setErrorModal({ open: true, message: error?.response?.data?.message || "Failed to fetch recharge history" });
    } finally {
      setLoading(false);
    }
  };
  console.log(" statatatat", RechargeHistory);
  useEffect(() => {

    fetchRechargeHistory();
    if (disableAddPlan !== null) {
      fetchSubscriptionHistory();
    }
  }, [disableAddPlan]);

  console.log(history.length);

  return (
    <div className="bg-accent-grey-50 h-full lg:w-[450px] w-full mx-auto">
      {/* <div className="flex items-center h-[56px]   rounded-bl-lg rounded-br-lg bg-black "></div>
      <div className="space-y-2.5 mt-[-23px] mx-4">
        <div className=" p-4 flex flex-col gap-3  border border-white bg-white  h-auto rounded-lg">
          <h3 className="text-black font-poppins font-bold text-base">
            History
          </h3>
        </div>
      </div> */}
      <Header />

      {loading ? (<ShimmerSkeleton />) : (

        <div>
          <div className="max-w-md mx-auto rounded-lg p-4">
            {/* Tabs */}
            <div className="flex rounded-full bg-[#1111110D]">
              <button
                className={`w-1/2 py-3 text-[15px] font-semibold ${activeTab === "recharge"
                  ? "bg-primary text-white rounded-full"
                  : " text-gray rounded-full"
                  }`}
                onClick={() => setActiveTab("recharge")}
              >
                Recharge
              </button>
              <button
                className={`w-1/2 py-3 text-[15px] font-semibold ${activeTab === "data-subscription"
                  ? "bg-primary text-white rounded-full"
                  : " text-gray rounded-full"
                  }`}
                onClick={() => setActiveTab("data-subscription")}
              >
                Data Subscription
              </button>
            </div>

            {/* Data Display */}
            {RechargeHistory ? (
              activeTab === "recharge" ? (
                RechargeHistory.length <= 0 ? (
                  <div className="container  h-screen">
                    <div className="py-5">
                      <div className="flex justify-center items-center">
                        <div className="space-y-4">
                          <div className="">
                            <img
                              src={nodata}
                              alt="no history"
                              className="w-full h-full"
                            />
                          </div>
                          <p className="font-poppins text-base font-medium text-accent-silver-900 text-center">
                            No History
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (<div className="mt-6 ">
                  {RechargeHistory.map((data, index) => (
                    <div key={index} className="mb-5 bg-primary/5 rounded-3xl p-6">
                      <div>
                        <div className="flex justify-between gap-2 text-[13px]">
                          <div className="flex flex-col gap-y-4">
                            <div>
                              <p className="text-gray">Description</p>
                              <p className="font-semibold">{data.DESCRIPTION}</p>
                            </div>
                            <div>
                              <p className="text-gray">Recharge Amount</p>
                              <p className="font-semibold">{data.VOUCHER_VALUE}</p>
                            </div>
                          </div>
                          <div className="flex flex-col gap-y-4">
                            <div className="text-left">
                              <p className="text-gray">Recharge Date</p>
                              <p className="font-semibold">{data.REDEEM_DATE}</p>
                            </div>
                            <div className="text-left">
                              <p className="text-gray">Dest Account</p>
                              <p className="font-semibold">{data.DEST_ACCOUNT}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>)

              ) : (
                history.length <= 0 ? (
                  <div className="container  h-screen">
                    <div className="py-5">
                      <div className="flex justify-center items-center">
                        <div className="space-y-4">
                          <div className="">
                            <img
                              src={nodata}
                              alt="no history"
                              className="w-full h-full"
                            />
                          </div>
                          <p className="font-poppins text-base font-medium text-accent-silver-900 text-center">
                            No History
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="mt-6 ">
                      {history.map((data, index) => (
                        data.PLAN !== "DATAEND" ? (
                          <div key={index} className="mb-5">
                            <div className="mb-5 bg-primary/5 rounded-3xl p-6">
                              <div className="flex  justify-between gap-2 text-[13px]">
                                <div className="flex  flex-col gap-y-4">
                                  <div>
                                    <p className="text-gray">Package name</p>
                                    <p className="font-semibold">{data.PLAN}</p>
                                  </div>
                                  <div>
                                    <p className="text-gray">Start Date</p>
                                    <p className="font-semibold">{data.START_DATE}</p>
                                  </div>
                                  <div>
                                    <p className="text-gray">Subscribed By</p>
                                    <p className="font-semibold">{data.CHARGE_USING === null ? "N/A" : data.CHARGE_USING}</p>
                                  </div>
                                </div>
                                <div className="flex flex-col gap-y-4">
                                  <div className="text-left">
                                    <p className="text-gray">Amount</p>
                                    <p className="font-semibold">{data.AMOUNT}</p>
                                  </div>
                                  <div className="text-left">
                                    <p className="text-gray">End Date</p>
                                    <p className="font-semibold">{data.END_DATE}</p>
                                  </div>
                                  <div>{" "}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div key={index} className="mb-5">
                            <div className="mb-5 bg-gradient-to-r from-gradiantprimary to-gradiantsecondary rounded-3xl p-6">
                              <div className="flex justify-between gap-2 text-[13px] text-white">
                                <div className="flex flex-col gap-y-4">
                                  <div>
                                    <p className="text-[#FFFFFF99]">Package name</p>
                                    <p className="font-semibold">{data.PLAN}</p>
                                  </div>
                                  <div>
                                    <p className="text-[#FFFFFF99]">Start Date</p>
                                    <p className="font-semibold">{data.START_DATE}</p>
                                  </div>

                                </div>
                                <div className="flex  justify-end flex-col gap-y-4">

                                  <div className="text-left">
                                    <p className="text-[#FFFFFF99]">End Date</p>
                                    <p className="font-semibold">{data.END_DATE}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )

                      ))}
                    </div>
                  </div>
                )
              )
            ) : (
              <p className="text-center text-gray-500 mt-4">Loading...</p>
            )}
          </div>
        </div>
      )}

      {/* Error Modal */}
      {errorModal.open && (
        <ErrorModal
          message={errorModal.message}
          close={() => setErrorModal({ open: false, message: "" })}
        />
      )}
    </div>
  );
};

export default History;
